import React, { useState, useEffect } from 'react';
import formSchema from '../../containers/BasicInfoForm/schema'
import { AdminInput } from '@project/components';
import { useIntl } from 'react-intl';
import { getNestedElement } from '../../utils/utils'

const classNames = require('classnames');

export default function MeasurementInput({ schemaKey, base, form, errors, isReadOnly, required, updateField, saveForm, customstyle }) {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  const value = getNestedElement(form, schemaKey);

  const [inches, setInches] = useState(value || value === 0 ? value % 12 : '');
  const [feet, setFeet] = useState(value || value === 0 ? Math.floor(value / 12) : '');
  const [isDirty, setIsDirty] = useState(false);

  const schema = getNestedElement(formSchema, schemaKey);
  const fieldKey = schemaKey.split('.').pop();
  const isValid = value && schema.validation ? String(value).match(schema.validation) : true;
  const hasError = Array.isArray(errors) && !!errors.find(_ => _.key === schemaKey);

  useEffect(() => {
    setInches(value || value === 0 ? value % 12 : '');
    setFeet(value || value === 0 ? Math.floor(value / 12) : '');
    setIsDirty(false);
  }, [value]);

  const handleMeasurementChange = ({ target: { value: fieldValue } }, type) => {
    setIsDirty(true);

    let totalInches = 0;
    if (type === 'feet') {
      totalInches = parseFloat(fieldValue || 0) * 12 + inches;
      setFeet(fieldValue === '' ? fieldValue : Math.floor(totalInches / 12));
      setInches(parseFloat((totalInches % 12).toFixed(5)));
    } else {
      totalInches = feet * 12 + parseFloat(fieldValue || 0);
      setFeet(Math.floor(totalInches / 12));
      setInches(fieldValue === '' ? fieldValue : parseFloat((totalInches % 12).toFixed(5)));
    }
  }

  const handleBlur = () => {
    if (isDirty) {
      updateField(fieldKey, { target: { type: 'number', value: feet * 12 + inches } }, base, false, schemaKey);
      saveForm(true);
      setIsDirty(false);
      if (inches === '') setInches(0);
      if (feet === '') setFeet(0);
    }
  }

  return (
    <div className={classNames('d-flex w-100')}>
      <div className='w-50 w-sm-100 mr-3'>
        <AdminInput
          id={[schemaKey, 'feet'].join('.')}
          label={required ? `${schema.label} (${t('unit.feet')}) *` : `${schema.label} (${t('unit.feet')})`}
          value={feet}
          onChange={(e) => handleMeasurementChange(e, 'feet')}
          isInvalid={!isValid || hasError}
          type="number"
          min={0}
          readOnly={isReadOnly}
          required={required}
          onBlur={handleBlur}
          validationmessage={intl.formatMessage({ id: 'AdminInput.validationMessage' }, { label: `${schema.label} (${t('unit.feet')})` })}
          customstyle={customstyle}
        />
      </div>
      <div className='w-50 w-sm-100'>
        <AdminInput
          id={[schemaKey, 'inches'].join('.')}
          label={required ? `${schema.label} (${t('unit.inches')}) *` : `${schema.label} (${t('unit.inches')})`}
          value={inches}
          min={0}
          onChange={(e) => handleMeasurementChange(e, 'inches')}
          isInvalid={!isValid || hasError}
          type="number"
          readOnly={isReadOnly}
          required={required}
          onBlur={handleBlur}
          validationmessage={intl.formatMessage({ id: 'AdminInput.validationMessage' }, { label: `${schema.label} (${t('unit.inches')})` })}
          customstyle={customstyle}
        />
      </div>
    </div>
  )
}
